<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Categorias de Conteúdo - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'contentCategories'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-content-category :btnLabel="btnLabel"></form-content-category>
</span>
</template>

<script>
import FormContentCategoryComponent from "./partial/FormContentCategoryComponent";

export default {
    name: "AddContentCategoryComponent",
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    methods: {

    },
    components: {
        formContentCategory: FormContentCategoryComponent,
    }
};
</script>

<style scoped>

</style>
